module.exports = __webpack_public_path__ + "img/logo.2ddd9929.png";